// src/components/Impact/Impact.js
import React from "react";
import { Container } from "react-bootstrap";
import foodBankImage from "../../Assets/Impact/foodbank_2024.jpg";
import workshopImage from "../../Assets/Impact/workshop_impact.jpg";

function Impact() {
  const impactStories = [
    {
      church: "Martin Evers Baptist Church",
      location: "Detroit, Michigan",
      dateAwarded: 2025,
      summary:
        "In 2025, Shared Success Foundation supported Martin Evers Baptist Church as it helped 20 families, including many young mothers, learn about homeownership and financial literacy. The grant helped cover transportation, childcare, meals, and follow-up support so participants could better understand credit, the homebuying process, tax benefits, and real estate investing. The church reports that 16 people are already moving in the right direction, and five are on track for approval by the end of March through partnerships with Lake Michigan Credit Union and Redeem Detroit.",
      images: [
        {
          src: workshopImage,
          alt: "Martin Evers Baptist Church financial literacy and homeownership event in Detroit."
        }
      ]
    },
    {
      church: "Northeastern Presbyterian Church",
      location: "Ward 5, Washington, DC",
      dateAwarded: 2024,
      summary:
        "Shared Success Foundation awarded Northeastern Presbyterian Church a $1,000 grant in 2024, and the church used every dollar to buy groceries for its volunteer-run food pantry. That support helped the pantry continue serving about 10 to 15 families each month, providing fresh and shelf-stable food for roughly 50 to 75 people, while giving families the dignity of choosing the items they needed most.",
      images: [
        {
          src: foodBankImage,
          alt: "Food pantry distribution supported by Northeastern Presbyterian Church in Washington, DC."
        }
      ]
    }
  ].sort((a, b) => b.dateAwarded - a.dateAwarded);

  return (
    <Container as="main" fluid className="project-section page-content">
      <Container>
        <div className="section-shell impact-shell">
          <div className="section-intro impact-intro">
            <span className="section-eyebrow">Impact</span>
            <h1 className="project-heading">How grant funding is showing up in the community.</h1>
            <p className="project-copy">
              Below is our most recent impact story, listed with the newest award first.
            </p>
          </div>

          <div className="impact-story-list">
            {impactStories.map((story) => (
              <article className="impact-feature" key={`${story.church}-${story.dateAwarded}`}>
                <div className="impact-feature-copy">
                  <div className="impact-meta-row">
                    <div className="impact-meta-card">
                      <span>Church</span>
                      <strong>{story.church}</strong>
                    </div>
                    <div className="impact-meta-card">
                      <span>Location</span>
                      <strong>{story.location}</strong>
                    </div>
                    <div className="impact-meta-card">
                      <span>Date Awarded</span>
                      <strong>{story.dateAwarded}</strong>
                    </div>
                  </div>

                  <p className="impact-story-summary">{story.summary}</p>
                </div>

                <div className={`impact-feature-image-wrap${story.images.length > 1 ? " impact-feature-gallery" : ""}`}>
                  {story.images.map((image) => (
                    <img
                      key={image.src}
                      src={image.src}
                      alt={image.alt}
                      className="impact-feature-image"
                    />
                  ))}
                </div>
              </article>
            ))}
          </div>
        </div>
      </Container>
    </Container>
  );
}

export default Impact;
